import { UIData } from '../../hooks/stores/uiStore';

interface ModalUtilsDependencies {
  UIData: UIData;
  setUIData: (data: Partial<UIData>) => void;
}

export function createModalUtils({
  UIData,
  setUIData,
}: ModalUtilsDependencies) {
  const openModal = (modalID: string) =>
    setUIData({ openModalIDs: [...UIData.openModalIDs, modalID] });

  const closeModal = (modalID: string) =>
    setUIData({
      openModalIDs: [...UIData.openModalIDs.filter((id) => id !== modalID)],
    });

  const toggleModal = (modalID: string) => {
    if (UIData.openModalIDs.includes(modalID)) {
      closeModal(modalID);
    } else {
      openModal(modalID);
    }
  };

  return {
    openModal,
    closeModal,
    toggleModal,
  };
} 